module.exports = __webpack_public_path__ + "img/413.88aa2187.jpg";